import CryptoJS from "crypto-js";

// Secret key for AES encryption/decryption.
// NOTE: This key is **mandatory** for encryption/decryption to work.
// If it is missing or incorrect, encryption and decryption will fail.
// Make sure REACT_APP_AUTH_SECRET_KEY is securely set in your environment variables.
const SECRET_KEY = process.env.REACT_APP_AUTH_SECRET_KEY;

if (!SECRET_KEY) {
    throw new Error("REACT_APP_AUTH_SECRET_KEY is not defined in the environment variables.");
}
/**
 * Encrypts the given auth object using AES and returns a ciphertext string.
 * @param auth - The authentication object to encrypt.
 * @returns Encrypted string.
 */
export function encryptAuth(auth: object): string {
    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(auth), SECRET_KEY!).toString();
    return ciphertext;
}

/**
 * Decrypts the given ciphertext string using AES and returns the original object.
 * @param ciphertext - The encrypted string to decrypt.
 * @returns Decrypted authentication object.
 */
export function decryptAuth(ciphertext: string): any {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY!);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
}
